<template>
	<div>
		<el-card class="box-card">
			<div style="padding:-20px">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>系统管理</el-breadcrumb-item>
					<el-breadcrumb-item>菜单管理</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</el-card>
		
		<el-card class="box-card mainPadding" >
			<el-button type="primary" @click="add()" icon="el-icon-plus" style="margin-bottom: 20px;" size="small">添加</el-button>
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column type="index" label="#" width="180">
				</el-table-column>
				<el-table-column prop="menuName" label="菜单名称">
				</el-table-column>
				<el-table-column prop="url" label="url">
				</el-table-column>
				<el-table-column prop="type" label="类型" width="100">
					<template slot-scope="scope">
						<el-button :type="scope.row.type === '菜单' ? 'primary' : 'warning'" disable-transitions size="mini">{{scope.row.type}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="sort" label="排序">
				</el-table-column>
				<el-table-column prop="cjDate" label="创建时间">
				</el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dcdfe6" disabled>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.$index,scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="small" @click="del(scope.$index,scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>

		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [{
					id: 1,
					menuName: '系统管理',
					url: '',
					type: '菜单',
					cjDate: '2020-04-24',
					status: true,
					sort: '1',
					children: [{
							id: 11,
							menuName: '角色管理',
							url: '/home/role',
							type: '菜单',
							cjDate: '2020-04-24',
							status: true,
							sort: '11',
							children: [{
									id: 111,
									menuName: '角色添加',
									url: '/home/role',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '111',
								},
								{
									id: 112,
									menuName: '角色删除',
									url: '/home/role',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '112',
								},
								{
									id: 113,
									menuName: '角色编辑',
									url: '/home/role',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '113',
								}
							]
						},
						{
							id: 2,
							menuName: '用户管理',
							url: '/home/user',
							type: '菜单',
							cjDate: '2020-04-24',
							status: true,
							sort: '2',
							children: [{
									id: 221,
									menuName: '用户添加',
									url: '/home/user',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '221',
								},
								{
									id: 222,
									menuName: '用户删除',
									url: '/home/user',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '222',
								},
								{
									id: 223,
									menuName: '用户编辑',
									url: '/home/user',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '223',
								}
							]
						},
						{
							id: 333,
							menuName: '部门管理',
							url: '/home/department',
							type: '菜单',
							cjDate: '2020-04-24',
							status: true,
							sort: '33',
							children: [{
									id: 331,
									menuName: '部门添加',
									url: '/home/department',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '331',
								},
								{
									id: 334,
									menuName: '部门删除',
									url: '/home/department',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '334',
								},
								{
									id: 332,
									menuName: '部门编辑',
									url: '/home/department',
									type: '按钮',
									cjDate: '2020-04-24',
									status: true,
									sort: '332',
								},
							]
						}
					]
				}, ],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}

			}
		},
		created() {},
		methods: {
			//获取表格数据
			getData() {
				alert('getData')

			},
			//编辑
			edit(index, row) {
				localStorage.setItem("row",JSON.stringify(row));
				this.$router.push({
					path: '/home/add'
				})
			},
			//权限
			jur() {
				this.dialogqxFormVisible = true
			},
			//添加
			add() {
				this.$router.push({
					path: '/home/add'
				})

			},
			//删除
			del(index,row) {
				console.log(index);
				console.log(row);
				this.$confirm('是否删除菜单' + row.menuName, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/system/menu.vue